import React, { Fragment } from 'react';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import ContactSection from '../../components/ContactSection';
import Journey from '../../components/journey/journey';


const ContactPage = (props) => {

    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <h1>Ease My Hotel is the most affordable and reliable <br/> Property management software for hotel and resort </h1>
                                    <br/>
                                    <p className='mb-0'>That’s why in just 11 months, we have our presence in more than 17+ countries.</p>
                                </div>
                            </div>
                        </div>
                </section>
                {/* <PageTitle pageTitle={'Contact Us'} pagesub={'Us 😍'} pageTop={'Contact'} /> */}
                <ContactSection />
                <Journey />
                {/* <CtaSection /> */}
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default ContactPage;